import React, { useState } from "react";
import NavItem from "./NavItem";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.jpg"

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <nav className="flex items-center justify-between flex-wrap bg-white-500 p-6">
            {/* <Link to="/">
                <div className="flex items-center flex-shrink-0 text-blue-500 mr-6">
                    <img src={Logo} height={54} width={54}  alt='' className="lg:mr-2"/>
                    <span className="font-semibold text-xl tracking-tight">Energi Masa Depan</span>
                </div>
            </Link> */}
            <div className="flex items-center flex-shrink-0 text-blue-500 mr-6">
                <img src={Logo} height={54} width={54} alt='' className="lg:mr-2" />
                <span className="font-semibold text-xl tracking-tight">Energi Masa Depan</span>
            </div>
            <div className="block lg:hidden">
                <button onClick={() => setIsOpen(!isOpen)} className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
                    <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                </button>
            </div>
            <div className={`${isOpen ? `block` : 'hidden'} w-full block flex-grow lg:flex lg:items-center lg:w-auto`}>
                <div className="text-sm lg:flex-grow">
                    <NavItem to="/sewa-milik-panel"> Sewa Milik Panel </NavItem>
                    <NavItem to="/simulasi-penghematan"> Simulasi Penghematan </NavItem>
                    <NavItem to="/mitra-energi"> Mitra Energi </NavItem>
                    <NavItem to="/teknologi-kami"> Teknologi Kami </NavItem>
                    <NavItem to="/tentang-kami"> Tentang Kami </NavItem>
                </div>
                <div>
                    <Link to="/login" className="inline-block text-sm px-4 py-2 leading-none border rounded text-black border-blue-500 hover:border-transparent hover:text-white hover:bg-blue-500 mt-4 lg:mt-0">
                        Login</Link>
                </div>
            </div>
        </nav>
    )
}
